import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* addUserSaga(action) {
  yield put(actions.addUserStart());
  try {
    const response = yield axios.post(
      '/users',
      action.formData
    );
    yield put(
      actions.initUsers(action)
    );
    yield put(
      actions.addUserSuccess(response.data, action)
    );
  } catch (error) {
    console.error('ERROR', error);
    yield put(actions.addUserFail(error));
  }
}

export function* initUsersSaga(action) {
  yield put(actions.initUsersStart());
  try {
    const response = yield axios.get(
      '/users'
    );
    yield put(actions.setActiveUser({}));
    yield put(actions.setUsers(response.data));
  } catch (error) {
    yield put(actions.fetchUsersFailed());
  }

}
export function* getOneUserSaga(action) {
  yield put(actions.getOneUserStart());
  try {
    const response = yield axios.get(
      '/users', {
        params: {
          username: action.username
        }
      }
    );
    yield put(
      yield put(actions.setActiveUser(response.data[0]))
    );
  } catch (error) {
    yield put(actions.getOneUserFail());
  }

}
export function* deleteUserSaga(action) {
  try {
    const response = yield axios.delete(
      '/users/' + action.userId
    );
    yield put(actions.initUsers(response.data));
  } catch (error) {
    yield put(actions.fetchUsersFailed());
  }

}
export function* editUserSaga(action) {
  yield put(actions.editUserStart());
  try {
    const response = yield axios.put(
      '/users/' + action.userId,
      action.payload
    );
    yield put(
      actions.editUserSuccess(response.data, action.payload)
    );
    if (action.payload.fromDetailsPage) {
      yield put(actions.getOneUser(action.payload.id));
    } else {
      yield put(actions.initUsers());
    }
  } catch (error) {
    console.error('ERROR', error);
    yield put(actions.editUserFail(error));
  }
}

